import "../stylesheets/App.css";
import "../stylesheets/Home.css";
import React, { useState, useEffect } from "react";
import HeaderHome from "./subcomponents/HeaderHome.js";
import SliderStages from "./subcomponents/SliderStages.js";
import Game from "./subcomponents/Game.js";
import Loader from "./subcomponents/Loader.js";
import FinalOfTheGame from "./subcomponents/FinalOfTheGame.js";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { manageInfoPopup } from "../utils/ManageInfoPopup.js";
import PopupInfo from "./subcomponents/PopupInfo.js";

// ✅ Mejor: crear el Context afuera (no se recrea en cada render)
export const BetsContext = React.createContext([]);

function Home() {
  const [loadingGames, setLoadingGames] = useState(true);
  const [loadingBets, setLoadingBets] = useState(true);
  const [loadingStages, setLoadingStages] = useState(true);
  const [loadingSliderStages, setLoadingSliderStages] = useState(true);

  const [refresh, setRefresh] = useState(false);
  const [openInfoPopup, setOpenInfoPopup] = useState(false);

  const [games, setGames] = useState([]);
  const [stages, setStages] = useState([]);
  const [bets, setBets] = useState([]);
  const [keywords, setKeywords] = useState("");

  const navigate = useNavigate();

  const apiCall = async (url) => {
    const r = await fetch(url);
    return r.json();
  };

  const getUserInfo = () => {
    const raw = localStorage.getItem("user-info");
    return raw ? JSON.parse(raw) : null;
  };

  useEffect(() => {
    // ✅ Redirecciones dentro del effect
    const user = getUserInfo();

    if (user?.is_admin) {
      navigate("/admin");
      return;
    }
    if (!user) {
      navigate("/login");
      return;
    }

    // popup info
    if (manageInfoPopup()) setOpenInfoPopup(true);

    // ✅ evitar crash si no existe el elemento
    const htmlRef = document.getElementById("html-ref");
    if (htmlRef) htmlRef.style.overflowY = "auto";

    // bets + stages
    const run = async () => {
      try {
        const idUser = user.idUser;

        const betsRes = await apiCall(
          `${process.env.REACT_APP_API_BASE_URL}/bets/listByUser/${idUser}`
        );
        setBets(betsRes?.data || []);
      } catch (e) {
        console.log(e);
      } finally {
        setLoadingBets(false);
      }

      try {
        const stagesRes = await apiCall(
          `${process.env.REACT_APP_API_BASE_URL}/stages/inProcessList`
        );
        setStages(stagesRes?.data || []);
      } catch (e) {
        console.log(e);
      } finally {
        setLoadingStages(false);
      }
    };

    run();

    // ✅ cada minuto (si querés cada hora, volvemos a 60*60*1000)
    const interval = setInterval(() => {
      if (manageInfoPopup()) setOpenInfoPopup(true);
    }, 60 * 60 * 1000);

    return () => clearInterval(interval);
  }, [navigate]);

  useEffect(() => {
    const run = async () => {
      setLoadingGames(true);
      try {
        const url =
          keywords !== ""
            ? `${process.env.REACT_APP_API_BASE_URL}/games/listWithKeywords/${keywords}`
            : `${process.env.REACT_APP_API_BASE_URL}/games/list`;

        const gamesRes = await apiCall(url);
        setGames(gamesRes?.data || []);
      } catch (e) {
        console.log(e);
      } finally {
        setLoadingGames(false);
        setRefresh(false);
      }
    };

    run();
  }, [keywords, refresh]);

  const isLoading = loadingGames || loadingBets || loadingStages || loadingSliderStages;

  return (
    <BetsContext.Provider value={bets}>
      <HeaderHome setKeywords={setKeywords} keywords={keywords} />

      {stages.length > 0 ? (
        <>
          <section className="home-stages-section">
            <h2 className="subtitles first-subtitle">Mis pronósticos</h2>
            <SliderStages setLoadingStages={setLoadingSliderStages} />
          </section>

          <section>
            <h2 className="subtitles ranking-subtitle">Rankings</h2>
            <div className="flex-container-button">
              <button
                className="btn red-btn btn-ranking"
                onClick={() => navigate("/stage-ranking")}
              >
                Fase
              </button>
              <button
                className="btn blue-btn  btn-ranking"
                onClick={() => navigate("/ranking")}
              >
                Global
              </button>
            </div>
          </section>

          <section>
            <h2 className="subtitles">Pronosticá los próximos partidos</h2>
            <ul>
              {games.map((game) =>
                game.teams?.length > 0 ? (
                  <li key={"li_" + game.idGame}>
                    <Game
                      key={"game_" + game.idGame}
                      data={game}
                      bet={bets.find((bet) => bet.game.idGame == game.idGame)}
                      setRefresh={setRefresh}
                    />
                  </li>
                ) : null
              )}
            </ul>
          </section>

          <section className="footer-section">
            <h2 className="subtitles">
              Para consultar y pronosticar todos los partidos, ingresa a las fases:
            </h2>

            {stages.map((stage) => {
              if (stage.active !== 1) return null;
              const route = "/stage/" + stage.idStage;

              return (
                <div
                  className="score-stage-title-container"
                  key={"score-title-" + stage.idStage}
                  onClick={() => navigate(route)}
                >
                  <h1 className="score-stage-title">
                    {stage.name === "Fase de clasificación"
                      ? "Fase de\nclasificación"
                      : stage.name}
                  </h1>
                  <div className="ranking-float-container">
                    <FontAwesomeIcon icon={solid("chevron-right")} size={"sm"} />
                  </div>
                </div>
              );
            })}
          </section>

          {isLoading ? <Loader /> : null}

          {openInfoPopup ? (
            <PopupInfo
              title=""
              description="¡Hola! Te recordamos que los pronósticos solo se podrán registrar y guardar con un límite de 15 minutos antes del inicio de cada partido. Si ingresás información después de este límite de tiempo, el pronóstico no será válido y no sumará puntos."
              setOpenPopup={setOpenInfoPopup}
            />
          ) : null}
        </>
      ) : loadingStages ? (
        <Loader />
      ) : (
        <FinalOfTheGame />
      )}
    </BetsContext.Provider>
  );
}

export default Home;
